import resourceFactory from 'common/admin/resourceFactory'

const actions = resourceFactory('cities')

export default actions
